import styled, { css } from 'styled-components'

import { device } from '~/styles/device'

export const RowWrapper = styled.div`
  ${({ theme }) => css`
    .LoadingContainer {
      margin-bottom: 0;
    }

    button + button {
      margin-left: 0.5rem;
    }

    &.hasBorder {
      & + .hasBorder {
        border-top: 1px solid ${theme.colors.tertiary};
        padding-top: 1rem;
      }
    }

    &:not(:first-child) {
      margin-top: 1rem;
    }
  `}
`

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: 0.125rem 0;

    .inputContainer {
      margin-top: 0.25rem;
    }

    /* O valor em display-3, como o desenho o mostra. */
    p {
      margin: 0;

      font: var(--sl-text-display-3-font);
      color: var(--sl-fg-base);

      + p {
        margin-top: 0.25rem;
      }

      .icon {
        &.success {
          color: ${theme.colors.success};
        }
      }
    }

    .dateLabel::first-letter {
      text-transform: capitalize;
    }

    strong {
      &.tag {
        color: ${theme.colors.white};
        font-size: ${theme.font.sizes.xsmall};
        padding: 0.125rem 0.5rem;
        border-radius: 0.5rem;
      }
      &.success {
        background: ${theme.colors.success};
      }
      &.danger {
        background: ${theme.colors.danger};
      }
    }

    .budget-alert {
      color: ${theme.colors.warning};
      border-color: ${theme.colors.warning};
    }

    /* O mínimo sugerido é dica abaixo do valor, em caption-1 crítico — a regra
       .review-min-warn do desenho. */
    small.budget-alert {
      font: var(--sl-text-caption-1-font);
      color: var(--sl-fg-critical);
    }

    .cpc-info {
      display: flex;
      > svg {
        margin-left: 0.25rem;
        margin-bottom: auto;
      }
    }
  `}
`

/**
 * Grade do card de investimento como o desenho o define —
 * `.review-invest-grid` em `apps/offsite/v2.html`: três colunas, sem divisória
 * entre elas, que é o que a leitura em coluna já separa.
 */
export const GroupWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sl-space-5);

  @media ${device.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${device.laptop} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`

/** Investimento total e objetivo lado a lado, nesta ordem. */
export const PairRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sl-space-5);

  @media ${device.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

/** Rótulo do valor: `caption-1` apagado, como os outros rótulos do desenho. */
export const Text = styled.strong`
  display: flex;
  align-items: center;

  margin-bottom: var(--sl-space-1);

  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);

  > div {
    margin-top: -0.1rem;
  }
`

/**
 * Barra de consumo do orçamento diário: no desenho ela fica **abaixo** do
 * valor, seguida do par usado/disponível numa linha só, e não numa caixa com
 * borda ao lado do valor.
 */
export const ContainerProgress = styled.div<{ $fixedWidth?: boolean }>`
  /**
   * Em leitura a barra ocupa a coluna inteira do card, que é o arranjo do
   * desenho. Na edição ela volta aos 15rem de antes, e não por gosto: ali o
   * bloco é item de um flex sem largura declarada, então a porcentagem
   * resolveria contra uma largura que o próprio conteúdo define — a barra
   * mudaria de tamanho conforme o valor gasto, ao lado de um input de largura
   * fixa. Os 15rem mantêm a coluna estável, como era antes deste arranjo.
   */
  width: ${({ $fixedWidth }) => ($fixedWidth ? '15rem' : '100%')};
  margin-top: var(--sl-space-2);

  /**
   * O afastamento do InputMoney ao lado, na edição. S.Wrapper não declara
   * gap ali (o container flex vem do d-flex do bootstrap), então sem isso a
   * barra encosta no input — o mesmo espaço que existia antes deste arranjo.
   */
  ${({ $fixedWidth, theme }) =>
    $fixedWidth &&
    css`
      margin-left: ${theme.spacings.medium};
    `}

  header {
    display: flex;
    justify-content: space-between;
    gap: var(--sl-space-4);

    margin-top: var(--sl-space-1);

    .column {
      display: flex;
      align-items: baseline;
      gap: var(--sl-space-1);

      .title,
      .value {
        margin: 0;

        font: var(--sl-text-caption-1-font);
        color: var(--sl-fg-base-soft);
      }

      .value {
        color: var(--sl-fg-base);
      }
    }
  }
`
